export function getFromPublic(url){
    return process.env.PUBLIC_URL + url
}